module.exports = __webpack_public_path__ + "static/media/minus.49f5a965.svg";